import React, { forwardRef, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { ButtonReg } from 'atoms/Buttons'
import { FormSelect } from 'atoms/Inputs'
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
  BaseDatePickerInput,
  Input,
  RequiredSign,
  Total,
  Error,
} from './styles'
import * as _ from 'lodash'

export class PumpingModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
    }
    this.errorsRef = {}
  }

  calcTotal(num1 = 0, num2 = 0) {
    return `${num2 - num1}`
  }

  onSubmit() {
    this.setState({ errors: {} })
    const { valid, errors } = this.isValid()
    if (valid) {
      const { pumpingData, fnSubmit } = this.props
      fnSubmit(pumpingData)
    } else {
      this.setState({ errors }, () => {
        errors[0] && 'ref' in errors[0] && this.errorsRef[`${errors[0].ref}`].focus()
      })
    }
  }

  isValid() {
    const { pumpingData } = this.props
    let errors = {}
    const validatingFields = _.pick(pumpingData, [
      'companyId',
      'contractorId',
      'shiftId',
      'noUnit',
      'hmStart',
      'hmEnd',
      'volumeStart',
      'volumeEnd',
    ])
    Object.keys(validatingFields).forEach((key) => {
      if (!validatingFields[key]) {
        errors[key] = {
          ref: key,
          message: 'field ini tidak boleh kosong',
        }
      }
    })
    if (parseInt(pumpingData.hmTotal) <= 0) {
      errors['hm'] = {
        ref: 'hmStart',
        message: 'Total HM tidak sesuai',
      }
    }
    if (parseInt(pumpingData.volumeTotal) <= 0) {
      errors['volume'] = {
        ref: 'volumeStart',
        message: 'Total Volume tidak sesuai',
      }
    }
    return { valid: Object.keys(errors).length < 1, errors }
  }

  render() {
    const {
      theme,
      pumpingData = {},
      isDisabled,
      fnChange,
      companiesList,
    } = this.props
    const { errors } = this.state

    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      arrowPos: 'calc(100% - 12px)',
      arrowSize: '16px',
    }

    const company = companiesList.find(c => c.id === pumpingData.companyId)
    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
      <BaseDatePickerInput
        onClick={onClick}
        ref={ref}
      >
        {value}
      </BaseDatePickerInput>
    ))

    return (
      <MainWrapper>
        <ModalHead>
          <Label
            lineheight={'29px'}
            size={'24px'}
            mb={'0px'}
          >
            {pumpingData.hasOwnProperty('id') ? 'Edit ' : 'Add New '}
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <div className="row">
            <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Company
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select Company'}
                  onChangeVal={(e) => fnChange(+e.target.value, 'companyId')}
                  options={companiesList}
                  value={pumpingData.companyId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['companyId'] = ref)}
                  {...inputConfig}
                />
                {'companyId' in errors && (
                  <Error>{errors.companyId.message}</Error>
                )}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Contractor
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select Contractor'}
                  onChangeVal={(e) => fnChange(e.target.value, 'contractorId')}
                  options={company ? company.contractors : []}
                  value={pumpingData.contractorId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['contractorId'] = ref)}
                  {...inputConfig}
                />
                {'contractorId' in errors && (
                  <Error>{errors.contractorId.message}</Error>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Date
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <div>
                  <DatePicker
                    selected={moment(pumpingData.date).toDate()}
                    onChange={(date) =>
                      fnChange(moment(date).format('YYYY-MM-DD'), 'date')
                    }
                    ref={(ref) => (this.errorsRef['date'] = ref)}
                    dateFormat={'yyyy-MM-dd'}
                    customInput={<DatePickerInput />}
                  />
                </div>
                {'date' in errors && <Error>{errors.date.message}</Error>}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Shift
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <FormSelect
                  placeholder={'Select Shift'}
                  onChangeVal={(e) => fnChange(e.target.value, 'shiftId')}
                  options={company ? company.companyShifts : []}
                  value={pumpingData.shiftId}
                  valField={'id'}
                  dispField={'name'}
                  ref={(ref) => (this.errorsRef['shiftId'] = ref)}
                  {...inputConfig}
                />
                {'shiftId' in errors && <Error>{errors.shiftId.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  No Unit
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="text"
                  placeholder="Enter no unit"
                  ref={(ref) => (this.errorsRef['noUnit'] = ref)}
                  value={pumpingData.noUnit}
                  onChange={(e) => fnChange(e.target.value, 'noUnit')}
                />
                {'noUnit' in errors && <Error>{errors.noUnit.message}</Error>}
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  HM Awal
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  ref={(ref) => (this.errorsRef['hmStart'] = ref)}
                  value={pumpingData.hmStart}
                  onChange={(e) => {
                    fnChange(e.target.value, 'hmStart')
                    fnChange(this.calcTotal(pumpingData.hmStart, pumpingData.hmEnd), 'hmTotal')
                  }}
                />
                {'hmStart' in errors && <Error>{errors.hmStart.message}</Error>}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  HM Akhir
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  ref={(ref) => (this.errorsRef['hmEnd'] = ref)}
                  value={pumpingData.hmEnd}
                  onChange={(e) => {
                    fnChange(e.target.value, 'hmEnd')
                    fnChange(this.calcTotal(pumpingData.hmStart, pumpingData.hmEnd), 'hmTotal')
                  }}
                />
                {'hmEnd' in errors && <Error>{errors.hmEnd.message}</Error>}
              </div>
            </div>
            <Label
              lineheight={'14px'}
              size={'12px'}
              mt={'16px'}
            >
              Total HM
              <RequiredSign>&nbsp;*</RequiredSign>
            </Label>
            <Total>
              {pumpingData.hmTotal}
            </Total>
            {'hm' in errors && <Error>{errors.hm.message}</Error>}
            <div className="row">
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Volume Awal
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  ref={(ref) => (this.errorsRef['volumeStart'] = ref)}
                  value={pumpingData.volumeStart}
                  onChange={(e) => {
                    fnChange(e.target.value, 'volumeStart')
                    fnChange(this.calcTotal(pumpingData.volumeStart, pumpingData.volumeEnd), 'volumeTotal')
                  }}
                />
                {'volumeStart' in errors && (
                  <Error>{errors.volumeStart.message}</Error>
                )}
              </div>
              <div className="col-6">
                <Label
                  lineheight={'14px'}
                  size={'12px'}
                  mt={'16px'}
                >
                  Volume Akhir
                  <RequiredSign>&nbsp;*</RequiredSign>
                </Label>
                <Input
                  type="number"
                  ref={(ref) => (this.errorsRef['volumeEnd'] = ref)}
                  value={pumpingData.volumeEnd}
                  onChange={(e) => {
                    fnChange(e.target.value, 'volumeEnd')
                    fnChange(this.calcTotal(pumpingData.volumeStart, pumpingData.volumeEnd), 'volumeTotal')
                  }}
                />
                {'volumeEnd' in errors && (
                  <Error>{errors.volumeEnd.message}</Error>
                )}
              </div>
            </div>
            <Label
              lineheight={'14px'}
              size={'12px'}
              mt={'16px'}
            >
              Total Volume
              <RequiredSign>&nbsp;*</RequiredSign>
            </Label>
            <Total>
              {pumpingData.volumeTotal}
            </Total>
            {'volume' in errors && <Error>{errors.volume.message}</Error>}
          </InputRow>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg
            onClick={this.props.fnSwitch}
            disabled={isDisabled}
            transparent
            btnTxt={'Cancel'}
          />
          <ButtonReg
            onClick={this.onSubmit.bind(this)}
            disabled={isDisabled}
            btnTxt={isDisabled ? 'Submitting...' : 'Submit'}
          />
        </ModalFooter>
      </MainWrapper>
    )
  }
}

export default withTheme(PumpingModal)
